import { render, staticRenderFns } from "./PageCover.vue?vue&type=template&id=aa3a7466&scoped=true"
import script from "./PageCover.vue?vue&type=script&lang=js"
export * from "./PageCover.vue?vue&type=script&lang=js"
import style0 from "./PageCover.vue?vue&type=style&index=0&id=aa3a7466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3a7466",
  null
  
)

export default component.exports